import events from './events'

export default app => {
  const v = app.config.globalProperties
  return {
    ...events(app),
    getDealer: function ({dealerId}) {
      return v.$http({
        method: 'get',
        headers: {'Authorization': 'Bearer ' + v.$auth.getAccessToken()},
        baseURL: v.$env.getAPIPrefixV1_1(),
        url: `/dealers/${dealerId}`,
        responseType: 'json',
        timeout: 1000 * 5,
      })
    },
  }
}
